import React, { useEffect, useRef, useState } from 'react';
import { deleteItem } from 'cms/utils/Network';
import { ApiHttpService } from 'cms/utils/http/api';

export default function PostPhotoGalleryItemController(item, onDelete) {

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const closeModal = () => {
    setModalIsOpen(false)
  }

  const _delete = () => {
    deleteItem(`postapi/photogallery`, item.id);
    closeModal()
    onDelete(item.id)
  }

 


  return {
    modalIsOpen,
    setModalIsOpen,
    _delete,
  };;
}
